import Vue, { CreateElement } from 'vue'
import { Component } from 'vue-property-decorator'

import TrainerPersonalInformation from '@src/routes/account/components/trainer-personal-information'
import TrainerChangePassword from '@src/routes/account/components/trainer-change-password'
import { ActionBar } from '@src/components/action-bar/action-bar'
import { Subtitle1, Subtitle2 } from '@src/elements/typography/typography'
import { Spacer } from '@src/elements/spacer/spacer'
import { track } from '@src/util/functions'
import DownloadLegalDocuments from '@src/components/download-legal/download-legal'

import './trainer-account.sass'

@Component
export default class TrainerAccount extends Vue {

  constructor () {
    super()
    track('/trainer/account')
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.MEMBERS.ACCOUNT.ACCOUNT_SETTINGS')}`
  }

  render (h: CreateElement) {
    return <div class='scroll-content'>
      <ActionBar>
        <Subtitle2 class='header'>{this.$t('PAGE.MEMBERS.ACCOUNT.ACCOUNT_SETTINGS')}</Subtitle2>
      </ActionBar>

      <div class='trainer-account-wrapper'>
        <TrainerPersonalInformation />

        <TrainerChangePassword />

        <Subtitle1>{this.$t('PAGE.MEMBERS.LEGAL.DOWNLOADS')}</Subtitle1>

        <Spacer />
        <DownloadLegalDocuments />
      </div>
    </div>
  }
}
